import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { ArrowLeft, CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md">
        <Link
          to="/login"
          className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-[#CCFF00] mb-6 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Zurück zum Login
        </Link>
        <div className="font-display text-xs tracking-[0.3em] text-[#CCFF00] mb-3">
          / PASSWORT VERGESSEN
        </div>

        {sent ? (
          <div data-testid="forgot-sent-state">
            <div className="w-12 h-12 border border-[#CCFF00]/40 bg-[#CCFF00]/10 flex items-center justify-center rounded-sm mb-6">
              <CheckCircle2 className="w-6 h-6 text-[#CCFF00]" />
            </div>
            <h1 className="font-heading font-black text-3xl leading-tight tracking-tight mb-4">
              Prüfe dein Postfach.
            </h1>
            <p className="text-white/70 leading-relaxed">
              Falls ein Konto zu <b>{email}</b> existiert, haben wir dir gerade
              einen Reset-Link geschickt. Der Link ist 60 Minuten gültig.
            </p>
            <p className="text-xs text-white/50 mt-6">
              Keine Mail bekommen? Prüfe den Spam-Ordner oder versuche es in ein paar Minuten erneut.
            </p>
          </div>
        ) : (
          <>
            <h1 className="font-heading font-black text-4xl leading-tight tracking-tight mb-4">
              Kein Problem.
            </h1>
            <p className="text-white/70 mb-8">
              Gib deine E-Mail-Adresse ein – wir schicken dir einen Link zum Zurücksetzen.
            </p>
            <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
              <div>
                <label className="font-display text-xs tracking-widest text-white/60 block mb-2">
                  E-Mail
                </label>
                <input
                  data-testid="forgot-email"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full bg-[#111214] border border-white/10 rounded-md px-4 py-3 text-white focus:border-[#CCFF00] outline-none transition-colors"
                />
              </div>
              <button
                data-testid="forgot-submit"
                disabled={loading}
                className="btn-primary w-full justify-center"
              >
                {loading ? "Wird gesendet …" : "Reset-Link anfordern"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
